<markant-platform-guided-tour-wrapper
  #guidedTourElement
  [guidedTourSteps]="steps"
  [onBack]="backButtonCallback"
  [onNext]="nextButtonCallback"
  [currentStep]="currentStep"
  [enableClickThrough]="enableClickThrough"
></markant-platform-guided-tour-wrapper>
<markant-platform-guided-tour-highlight-dialog
  *ngIf="currentStep === 4"
  targetId="my-groups-tour-step4-dialog"
  textBaseKey="guidedTour.tours.guided-tour-oa-admin-area.section5"
  [dialogPosition]="dialogConfig.position"
  [currentStep]="currentStep"
  (next)="nextTarget()"
>
  <markant-platform-group-assignment-demo
    slot="highlight-dialog-static-view-content"
  ></markant-platform-group-assignment-demo>
</markant-platform-guided-tour-highlight-dialog>
